export interface GossipTimelineItem {
  date: string;
  text: string;
}

export interface GossipItem {
  id: string;
  rank: number;
  heat: number;
  category: string;
  status: string;
  date: string;
  title: string;
  summary: string;
  people: string[];
  conflict: string;
  tags: string[];
  cover: string;
  timeline: GossipTimelineItem[];
  detail: string;
}

export const gossipCategories = [
  { key: "全部", label: "全部大盘点", icon: "ri-layout-grid-line" },
  { key: "恋情绯闻", label: "恋情绯闻", icon: "ri-heart-3-line" },
  { key: "剧组风波", label: "剧组风波", icon: "ri-film-line" },
  { key: "合约解约", label: "合约解约", icon: "ri-file-paper-2-line" },
  { key: "舞台争议", label: "舞台争议", icon: "ri-mic-line" },
  { key: "商业代言", label: "商业代言", icon: "ri-shopping-bag-3-line" },
  { key: "形象争议", label: "形象争议", icon: "ri-user-voice-line" },
  { key: "综艺名场面", label: "综艺名场面", icon: "ri-tv-2-line" },
];

export const gossipStats = [
  { value: "30", label: "条爆料盘点", icon: "ri-stack-line" },
  { value: "8", label: "主题分类", icon: "ri-folders-line" },
  { value: "96", label: "个冲突节点", icon: "ri-flashlight-line" },
  { value: "12万+", label: "条网友讨论", icon: "ri-chat-3-line" },
];

export const gossipFaqs = [
  {
    question: "「瓜网30」的 30 个瓜是怎么筛出来的？",
    answer:
      "我们按近一个月内讨论量、话题延续性和信息增量三个维度做筛选，再去掉只有单条截图、无法互相印证的传闻，最终保留 30 条能理清来龙去脉的事件。每条都会标注核心人物、冲突点与当前状态。",
  },
  {
    question: "每条瓜旁边的「冲突点」代表什么？",
    answer:
      "冲突点指的是这条事件里真正的分歧所在，比如双方说法不一致、粉丝解读对立、或者是当事方与剧组的立场差。抓住冲突点，基本就抓住了这条瓜的关键。",
  },
  {
    question: "为什么有的瓜状态写着「已澄清」，有的写「待回应」？",
    answer:
      "状态反映的是我们整理时的公开进展。当事方已经出面说明并给出证据的，标记为已澄清；事件双方都还没正面回应的，标记为待回应；仍在持续更新中的，标记为持续发酵。状态会随后续进展调整。",
  },
  {
    question: "网站里的艺人名字是真实人物吗？",
    answer:
      "本站内容为网友投稿与公开讨论的整理汇总，涉及人物均使用虚构艺名或化名，仅用于呈现事件结构与讨论脉络，请勿对号入座，也不建议作为任何判断依据。",
  },
  {
    question: "我可以投稿或者指出内容错误吗？",
    answer:
      "当然可以。在「联系我们」页面填写投稿或纠错表单即可，写清事件大致时间、涉及作品或节目、以及你想补充或更正的信息。我们会人工核对后再决定是否更新条目。",
  },
  {
    question: "为什么同一条瓜在不同平台的描述差别很大？",
    answer:
      "因为传播过程中常被截取片段。我们的做法是把时间线拉出来，从最早的信号排到最近的发酵，让你自己看到信息是怎么一步步变形的，而不是只给你一个结论。",
  },
];

export const gossipList: GossipItem[] = [
  {
    id: "lin-gu-midnight",
    rank: 1,
    heat: 9860,
    category: "恋情绯闻",
    status: "持续发酵",
    date: "2026-09-08",
    title: "深夜同框照流出：林见夏与顾斯衡被拍到前后脚返回同一小区",
    summary: "狗仔连拍三晚，两人行程高度重合却始终不同框，双方工作室默契沉默，粉丝阵营解读彻底对立。",
    people: ["林见夏", "顾斯衡"],
    conflict: "「只是同小区邻居」与「已稳定交往」两种说法在评论区正面碰撞。",
    tags: ["深夜同框", "工作室沉默", "行程重合"],
    cover: "https://readdy.ai/api/search-image?query=Single%20spotlight%20beam%20on%20an%20empty%20theater%20stage%20with%20drifting%20smoke%2C%20warm%20amber%20and%20crimson%20tones%2C%20cinematic%20editorial%20magazine%20aesthetic%2C%20no%20people%2C%20no%20text&width=800&height=500&seq=gw-cover-01&orientation=landscape",
    timeline: [
      { date: "9月2日", text: "首组照片曝光，两人从同一地下车库先后驶出，间隔不到十分钟。" },
      { date: "9月5日", text: "行程博主列出两人近三个月重合的 11 次通告城市，话题登上热榜。" },
      { date: "9月8日", text: "双方工作室均未回应，林见夏后援会发布「理智追星」长文，评论区出现分歧。" },
    ],
    detail:
      "这条瓜之所以能冲到第一，不是因为照片有多实锤，而是因为「不回应」本身构成了新的信息增量。从时间线看，事件经历了从影像证据到行程比对，再到粉丝内部立场分裂三个阶段，讨论重心已经从「是否恋爱」转向「为什么不回应」，这也是它迟迟不下热榜的原因。",
  },
  {
    id: "su-lu-on-set",
    rank: 2,
    heat: 9420,
    category: "剧组风波",
    status: "待回应",
    date: "2026-09-07",
    title: "剧组现场争执视频流传：苏晚棠与陆时安被指合作出现裂痕",
    summary: "一段只有十几秒的现场视频被反复解读，剧方称是走戏讨论，但剪辑版本之间差异明显。",
    people: ["苏晚棠", "陆时安"],
    conflict: "剧方「正常对戏」的说法与视频中明显的情绪状态之间的矛盾。",
    tags: ["现场视频", "走戏争议", "剧方回应"],
    cover: "https://readdy.ai/api/search-image?query=Clapperboard%20and%20film%20reel%20silhouette%20on%20a%20wooden%20table%2C%20warm%20amber%20backlight%2C%20cinematic%20editorial%20magazine%20aesthetic%2C%20no%20people%2C%20no%20text&width=800&height=500&seq=gw-cover-02&orientation=landscape",
    timeline: [
      { date: "9月3日", text: "现场视频片段在短视频平台流传，配文称「两人当场起争执」。" },
      { date: "9月5日", text: "剧方发布简短说明，称是走戏时的正常讨论，呼吁不要过度解读。" },
      { date: "9月7日", text: "有网友放出更长版本，画面内容与短版衔接不上，事件再次升温。" },
    ],
    detail:
      "这是典型的「视频证据本身成为争议点」的案例。短版强调情绪，长版强调上下文，两版拼在一起反而让结论更模糊。目前剧方只做了一次口径统一的说明，没有补充物料，因此状态仍是待回应。",
  },
  {
    id: "jiang-contract",
    rank: 3,
    heat: 9180,
    category: "合约解约",
    status: "持续发酵",
    date: "2026-09-06",
    title: "江砚辞被曝提前解约，经纪公司回应「正在协商」",
    summary: "合作五年突然传出解约，双方口径一冷一热，粉丝从合约公告里找出了三处时间差。",
    people: ["江砚辞", "星野文化"],
    conflict: "「个人发展需要」与「合约期未满」之间的表述落差。",
    tags: ["提前解约", "合约期", "工作室"],
    cover: "https://readdy.ai/api/search-image?query=Signed%20contract%20papers%20and%20a%20brass%20desk%20lamp%20on%20a%20dark%20wood%20desk%2C%20warm%20amber%20light%2C%20cinematic%20editorial%20magazine%20aesthetic%2C%20no%20people%2C%20no%20text&width=800&height=500&seq=gw-cover-03&orientation=landscape",
    timeline: [
      { date: "9月1日", text: "业内账号爆料江砚辞已递交解约函，双方进入协商阶段。" },
      { date: "9月3日", text: "经纪公司回应「正在协商，感谢关心」，未否认解约传闻。" },
      { date: "9月6日", text: "粉丝整理出近两年通告排期对比，指出空窗期异常，话题持续发酵。" },
    ],
    detail:
      "解约类事件的关键往往不在情绪，而在时间线。粉丝这次没有情绪化开战，而是做了排期表和合约节点比对，让事件从「谁对谁错」变成「合约怎么算」，讨论质量明显高于同类话题。",
  },
  {
    id: "wen-lipsync",
    rank: 4,
    heat: 8940,
    category: "舞台争议",
    status: "已澄清",
    date: "2026-09-05",
    title: "温亦寒巡演被质疑假唱，主办方放出监棚音频回应",
    summary: "现场收音异常引发质疑，主办方第二天放出多轨监棚音频，争议基本平息但仍有讨论。",
    people: ["温亦寒"],
    conflict: "现场听感与监棚音频之间的差距该由谁负责解释。",
    tags: ["假唱疑云", "监棚音频", "巡演"],
    cover: "https://readdy.ai/api/search-image?query=Vintage%20studio%20microphone%20on%20a%20stand%20with%20warm%20rim%20light%2C%20amber%20and%20crimson%20tones%2C%20cinematic%20editorial%20magazine%20aesthetic%2C%20no%20people%2C%20no%20text&width=800&height=500&seq=gw-cover-04&orientation=landscape",
    timeline: [
      { date: "9月4日", text: "巡演现场片段流出，部分高音段落听感平稳，被质疑假唱。" },
      { date: "9月5日", text: "主办方放出多轨监棚音频与现场拾音对比，标注了气口与换气点。" },
      { date: "9月6日", text: "相关话题热度回落，多数讨论转向「现场混音标准」的技术层面。" },
    ],
    detail:
      "这是一条少见的「靠物料平息」的瓜。主办方没有打感情牌，而是给出了可验证的音频对比，把争议从人品判断拉回技术讨论。状态标记为已澄清，但关于大型巡演混音标准的讨论仍在持续。",
  },
  {
    id: "bai-endorsement",
    rank: 5,
    heat: 8720,
    category: "商业代言",
    status: "已落幕",
    date: "2026-09-04",
    title: "白鹿遥代言到期未续，品牌方默契换人引发连锁解读",
    summary: "一个正常的合约到期，被拆解成了三条不同版本的「内幕」，最终品牌方一句说明平息。",
    people: ["白鹿遥"],
    conflict: "「正常到期」与「合作不快」两种叙事谁更可信。",
    tags: ["代言到期", "品牌换人", "连锁解读"],
    cover: "https://readdy.ai/api/search-image?query=Elegant%20perfume%20bottle%20on%20a%20marble%20pedestal%20with%20warm%20amber%20side%20light%2C%20cinematic%20editorial%20magazine%20aesthetic%2C%20no%20people%2C%20no%20text&width=800&height=500&seq=gw-cover-05&orientation=landscape",
    timeline: [
      { date: "8月28日", text: "品牌官方账号悄然下架白鹿遥相关物料，引发粉丝关注。" },
      { date: "9月1日", text: "多个账号放出「合作不快」的说法，但均无信源。" },
      { date: "9月4日", text: "品牌方说明为合约自然到期，感谢过往合作，话题迅速降温。" },
    ],
    detail:
      "商业代言类事件最大的信息来源是「物料下架时间」，而这恰恰是最容易被过度解读的。这条瓜的价值在于它展示了一个完整的信息失真过程：从一个正常的物料更换，长出了三种互相矛盾的版本。",
  },
  {
    id: "shen-xu-breakup",
    rank: 6,
    heat: 8530,
    category: "恋情绯闻",
    status: "已澄清",
    date: "2026-09-03",
    title: "沈砚清与许南枝被曝分手，双方共同好友发文间接回应",
    summary: "取关、清空、删合照三连操作引发猜测，最后被证实是账号整理，乌龙收场。",
    people: ["沈砚清", "许南枝"],
    conflict: "社交账号的「清理动作」能否等同于关系变化。",
    tags: ["取关", "清空动态", "乌龙"],
    cover: "https://readdy.ai/api/search-image?query=Wilting%20red%20roses%20on%20a%20dressing%20table%20with%20soft%20warm%20light%2C%20amber%20tones%2C%20cinematic%20editorial%20magazine%20aesthetic%2C%20no%20people%2C%20no%20text&width=800&height=500&seq=gw-cover-06&orientation=landscape",
    timeline: [
      { date: "8月30日", text: "网友发现两人互相取关，历史合照被批量归档。" },
      { date: "9月1日", text: "共同好友发文称「别乱猜」，未直接否认分手。" },
      { date: "9月3日", text: "沈砚清工作室说明账号由新团队统一整理，事件定性为乌龙。" },
    ],
    detail:
      "这是「用社交行为反推私人关系」的典型案例，也是最容易翻车的一类推理。整条事件从发酵到澄清只用了四天，但相关截图至今仍在被当作「实锤」二次传播，值得警惕。",
  },
  {
    id: "tang-screentime",
    rank: 7,
    heat: 8360,
    category: "剧组风波",
    status: "持续发酵",
    date: "2026-09-02",
    title: "唐以宁被指加戏，原著粉与剧组就剧本改动正面冲突",
    summary: "原著粉逐集比对台词量，剧组强调剧本改编早已定稿，双方在「契约精神」上各说各话。",
    people: ["唐以宁", "剧组方"],
    conflict: "演员个人诉求与整体剧本结构之间的边界在哪里。",
    tags: ["加戏争议", "原著改编", "台词量"],
    cover: "https://readdy.ai/api/search-image?query=Neat%20stack%20of%20screenplay%20pages%20beside%20a%20cup%20of%20coffee%20on%20a%20desk%2C%20warm%20amber%20light%2C%20cinematic%20editorial%20magazine%20aesthetic%2C%20no%20people%2C%20no%20text&width=800&height=500&seq=gw-cover-07&orientation=landscape",
    timeline: [
      { date: "8月26日", text: "原著粉发布逐集台词量统计表，指出某角色戏份明显增加。" },
      { date: "8月29日", text: "剧组回应称剧本改编在开拍前已定稿，不存在临时加戏。" },
      { date: "9月2日", text: "双方各自更新长图，讨论转向「改编权限与演员话语权」。" },
    ],
    detail:
      "这条瓜的核心其实不是某位演员，而是「改编权归谁」这个行业老问题。粉丝用数据说话的方式让讨论变得具体，但也把创作决策简化成了数字对比，这也是双方始终谈不拢的原因。",
  },
  {
    id: "cheng-variety",
    rank: 8,
    heat: 8140,
    category: "综艺名场面",
    status: "持续发酵",
    date: "2026-09-01",
    title: "程知遥综艺一句话上热搜，被解读出三种完全不同的意思",
    summary: "同一句话在三个平台被剪成三种字幕，观众各取所需，节目组直到第三天才放出完整版。",
    people: ["程知遥"],
    conflict: "字幕与语境缺失导致的解读自由度过大。",
    tags: ["综艺金句", "字幕争议", "完整版"],
    cover: "https://readdy.ai/api/search-image?query=Empty%20television%20studio%20set%20with%20warm%20spotlights%20and%20colorful%20bokeh%2C%20cinematic%20editorial%20magazine%20aesthetic%2C%20no%20people%2C%20no%20text&width=800&height=500&seq=gw-cover-08&orientation=landscape",
    timeline: [
      { date: "8月30日", text: "节目片段流出，一句反问被剪成短句广泛传播。" },
      { date: "9月1日", text: "不同平台出现三种字幕版本，含义差别很大，话题登上热搜。" },
      { date: "9月2日", text: "节目组放出完整对话版本，语境补齐后讨论逐渐理性。" },
    ],
    detail:
      "一句话能上热搜，往往说明它足够模糊。这条瓜真正值得注意的是「字幕版本打架」这个现象，它比事件本身更能说明当下的传播环境。",
  },
  {
    id: "ji-old-photos",
    rank: 9,
    heat: 7980,
    category: "形象争议",
    status: "已澄清",
    date: "2026-08-31",
    title: "季言旧照被翻出引发讨论，工作室说明为剧照花絮",
    summary: "一组风格反差很大的照片被当作「黑历史」传播，工作室两小时内给出拍摄来源。",
    people: ["季言"],
    conflict: "旧内容的时代语境能否用今天的标准衡量。",
    tags: ["旧照", "剧照花絮", "快速澄清"],
    cover: "https://readdy.ai/api/search-image?query=Old%20photographs%20scattered%20on%20a%20wooden%20floor%20with%20warm%20amber%20sunlight%2C%20cinematic%20editorial%20magazine%20aesthetic%2C%20no%20people%2C%20no%20text&width=800&height=500&seq=gw-cover-09&orientation=landscape",
    timeline: [
      { date: "8月31日", text: "一组反差不小的照片被二次传播，配文带有明显引导性。" },
      { date: "8月31日", text: "工作室两小时内发布说明，附上剧照花絮的原始出处。" },
      { date: "9月1日", text: "原始出处页面被大量查看，讨论转向「断章取义」本身。" },
    ],
    detail:
      "处理速度快是这条瓜迅速降温的关键。工作室没有长篇辩解，直接给出原始出处链接，让信息可被验证。这也是「已澄清」状态里最干净的一次收尾。",
  },
  {
    id: "ruan-studio",
    rank: 10,
    heat: 7820,
    category: "合约解约",
    status: "已落幕",
    date: "2026-08-30",
    title: "阮清和成立个人工作室，与老东家和平分手",
    summary: "没有撕破脸，也没有互撕长文，一条联合声明解决了所有猜测。",
    people: ["阮清和"],
    conflict: "粉丝希望「继续合作」与团队希望「独立运营」的期待差。",
    tags: ["个人工作室", "和平解约", "联合声明"],
    cover: "https://readdy.ai/api/search-image?query=Cozy%20small%20studio%20office%20with%20warm%20desk%20lamp%20and%20plants%20at%20dusk%2C%20amber%20tones%2C%20cinematic%20editorial%20magazine%20aesthetic%2C%20no%20people%2C%20no%20text&width=800&height=500&seq=gw-cover-10&orientation=landscape",
    timeline: [
      { date: "8月24日", text: "工作室注册信息被工商平台收录，随即被发现。" },
      { date: "8月27日", text: "老东家与本人发布联合声明，确认合约期满不再续约。" },
      { date: "8月30日", text: "新团队公布首个项目计划，事件以正面收尾。" },
    ],
    detail:
      "这是 30 条里少有的「没有争议」的条目，但它依然有价值：它证明了联合声明这种形式可以一次性消化所有猜测，避免信息真空带来的二次发酵。",
  },
  {
    id: "huo-late",
    rank: 11,
    heat: 7640,
    category: "舞台争议",
    status: "已澄清",
    date: "2026-08-29",
    title: "霍屿音乐节迟到二十分钟，主办方与艺人各执一词后统一口径",
    summary: "开场延后引发不满，双方先各说各话，最后用一张时间表把责任分清楚。",
    people: ["霍屿", "音乐节主办方"],
    conflict: "调音调试时间该由谁承担，责任划分一度模糊。",
    tags: ["音乐节迟到", "调音时间", "时间表"],
    cover: "https://readdy.ai/api/search-image?query=Outdoor%20music%20festival%20stage%20at%20night%20with%20warm%20amber%20lights%20and%20haze%2C%20cinematic%20editorial%20magazine%20aesthetic%2C%20no%20people%2C%20no%20text&width=800&height=500&seq=gw-cover-11&orientation=landscape",
    timeline: [
      { date: "8月28日", text: "压轴演出延后二十分钟开场，现场观众情绪明显。" },
      { date: "8月29日", text: "艺人团队称设备调试超时，主办方最初回应时间线不一致。" },
      { date: "8月29日", text: "双方共同发布带时刻的流程表，争议基本平息。" },
    ],
    detail:
      "「时间表」是这次收尾的关键物料。当双方口径冲突时，能落到具体时刻的表格比任何声明都有效，这也是演出纠纷里最值得复制的处理方式。",
  },
  {
    id: "xie-endorse-trouble",
    rank: 12,
    heat: 7460,
    category: "商业代言",
    status: "持续发酵",
    date: "2026-08-28",
    title: "谢云深代言产品被投诉，品牌方与粉丝就「责任归属」争执不下",
    summary: "产品售后问题演变成代言人责任讨论，双方都在强调自己不负责售后。",
    people: ["谢云深", "品牌方"],
    conflict: "代言人的道义责任与法律责任之间的落差。",
    tags: ["代言翻车", "售后投诉", "责任边界"],
    cover: "https://readdy.ai/api/search-image?query=Product%20packaging%20boxes%20on%20a%20retail%20shelf%20under%20warm%20amber%20lighting%2C%20cinematic%20editorial%20magazine%20aesthetic%2C%20no%20people%2C%20no%20text&width=800&height=500&seq=gw-cover-12&orientation=landscape",
    timeline: [
      { date: "8月22日", text: "多位消费者在投诉平台反馈同一产品的售后问题。" },
      { date: "8月25日", text: "讨论开始转向代言人，粉丝强调代言人不参与产品与售后。" },
      { date: "8月28日", text: "品牌方发布售后升级方案，但未回应代言人相关讨论。" },
    ],
    detail:
      "这条事件的讨论重心从产品跑到了代言人，是典型的议题转移。真正值得关注的其实是品牌的售后响应速度，但舆论的注意力被角色责任之争吸引走了。",
  },
  {
    id: "qiao-luo-engagement",
    rank: 13,
    heat: 7340,
    category: "恋情绯闻",
    status: "待回应",
    date: "2026-08-27",
    title: "乔安禾与罗晚舟疑似订婚，一枚戒指引发全网找同款",
    summary: "同款戒指、同框行程、家长聚会三个线索叠加，双方目前都未回应。",
    people: ["乔安禾", "罗晚舟"],
    conflict: "「戒指同款」这类间接证据的证明力到底有多强。",
    tags: ["同款戒指", "家长同框", "待回应"],
    cover: "https://readdy.ai/api/search-image?query=Delicate%20gold%20ring%20resting%20on%20dark%20velvet%20with%20warm%20amber%20highlights%2C%20cinematic%20editorial%20magazine%20aesthetic%2C%20no%20people%2C%20no%20text&width=800&height=500&seq=gw-cover-13&orientation=landscape",
    timeline: [
      { date: "8月21日", text: "机场照中出现的戒指被指与另一人款式一致。" },
      { date: "8月24日", text: "有网友称在三亚偶遇两人与长辈同行，但无清晰影像。" },
      { date: "8月27日", text: "相关话题热度持续，双方工作室均未作任何回应。" },
    ],
    detail:
      "这是三条线索叠加的典型「拼图型」传闻。单看每条都不足以定论，叠加之后却产生了很强的说服力，但其中「同框」这一条始终没有影像支撑，也是事件停在待回应状态的原因。",
  },
  {
    id: "chi-bodydouble",
    rank: 14,
    heat: 7160,
    category: "剧组风波",
    status: "持续发酵",
    date: "2026-08-26",
    title: "池砚被曝大量使用替身，剧组回应称涉及专业动作戏份",
    summary: "动作替身名单流出后引发演技讨论，剧组强调危险动作使用替身是行业常规。",
    people: ["池砚", "剧组方"],
    conflict: "「专业分工」与「敬业程度」被混为一谈。",
    tags: ["替身争议", "动作戏", "行业常规"],
    cover: "https://readdy.ai/api/search-image?query=Camera%20lens%20close%20up%20with%20warm%20amber%20bokeh%20and%20dramatic%20rim%20light%2C%20cinematic%20editorial%20magazine%20aesthetic%2C%20no%20people%2C%20no%20text&width=800&height=500&seq=gw-cover-14&orientation=landscape",
    timeline: [
      { date: "8月23日", text: "一份替身工作名单在行业群内流出，被转发至公开平台。" },
      { date: "8月25日", text: "剧组说明涉及高空与爆破场次，均属安全规范要求。" },
      { date: "8月26日", text: "讨论转向「演员与替身的边界」，争议未完全平息。" },
    ],
    detail:
      "替身争议每隔一段时间就会出现一次，说明公众对剧组分工仍缺乏了解。剧组的说明基本符合行业惯例，但「使用比例」这一关键信息始终没有公开，这也是争议延续的原因。",
  },
  {
    id: "min-livestream",
    rank: 15,
    heat: 6980,
    category: "形象争议",
    status: "已澄清",
    date: "2026-08-25",
    title: "闵星野直播失言引争议，本人次日开播完整回应",
    summary: "一次口误被剪成十五秒短视频传播，本人没有回避，直接开了完整回放。",
    people: ["闵星野"],
    conflict: "片段传播与完整语境之间的落差。",
    tags: ["直播失言", "完整回放", "正面回应"],
    cover: "https://readdy.ai/api/search-image?query=Ring%20light%20and%20microphone%20in%20a%20dark%20streaming%20room%20with%20warm%20amber%20glow%2C%20cinematic%20editorial%20magazine%20aesthetic%2C%20no%20people%2C%20no%20text&width=800&height=500&seq=gw-cover-15&orientation=landscape",
    timeline: [
      { date: "8月24日", text: "十五秒剪辑片段被广泛转发，配文指向「不当言论」。" },
      { date: "8月25日", text: "本人次日开播，完整回放原始直播片段并逐句说明。" },
      { date: "8月25日", text: "原直播回放数据大幅上涨，讨论转向剪辑本身。" },
    ],
    detail:
      "正面回应是这条瓜能快速收尾的原因。本人没有用声明回避，而是把原始素材直接摆出来，让观众自己比对，这种方式在直播类争议里效果最好。",
  },
  {
    id: "pei-rescue",
    rank: 16,
    heat: 6820,
    category: "综艺名场面",
    status: "已落幕",
    date: "2026-08-24",
    title: "裴听澜一句话救场被赞高情商，片段单日播放破千万",
    summary: "同场嘉宾冷场两秒，一句自然接话化解尴尬，成为今年传播最广的综艺片段之一。",
    people: ["裴听澜"],
    conflict: "「高情商发言」是否被过度神化。",
    tags: ["高情商救场", "冷场", "播放破千万"],
    cover: "https://readdy.ai/api/search-image?query=Warm%20variety%20show%20stage%20with%20soft%20amber%20lights%20and%20empty%20round%20table%2C%20cinematic%20editorial%20magazine%20aesthetic%2C%20no%20people%2C%20no%20text&width=800&height=500&seq=gw-cover-16&orientation=landscape",
    timeline: [
      { date: "8月23日", text: "节目播出后片段被剪辑传播，播放量迅速攀升。" },
      { date: "8月24日", text: "同场嘉宾在采访中证实当时确实冷场，话题进一步扩散。" },
      { date: "8月24日", text: "片段单日播放破千万，成为当期节目最高传播内容。" },
    ],
    detail:
      "这是 30 条里唯一没有争议、纯粹靠正面传播上榜的条目。它能火，说明观众对「让场面舒服」的能力有真实偏好，也说明综艺片段依然是娱乐内容最有效的传播单位。",
  },
  {
    id: "lin-contract-end",
    rank: 17,
    heat: 6640,
    category: "合约解约",
    status: "持续发酵",
    date: "2026-08-23",
    title: "林见夏合约期满未官宣，新团队人选传闻满天飞",
    summary: "合约节点已过半个月，双方均未发声明，各种版本的团队名单在网上流传。",
    people: ["林见夏"],
    conflict: "信息真空期里，传闻的可信度该由谁背书。",
    tags: ["合约期满", "新团队", "信息真空"],
    cover: "https://readdy.ai/api/search-image?query=Hourglass%20with%20glowing%20amber%20sand%20on%20a%20dark%20desk%2C%20cinematic%20editorial%20magazine%20aesthetic%2C%20no%20people%2C%20no%20text&width=800&height=500&seq=gw-cover-17&orientation=landscape",
    timeline: [
      { date: "8月8日", text: "合约到期节点到来，双方均未发布任何相关公告。" },
      { date: "8月18日", text: "多份「新团队名单」在不同社群流传，版本互相矛盾。" },
      { date: "8月23日", text: "热度不减，但至今没有任何一方给出官方口径。" },
    ],
    detail:
      "空窗期越长，传闻越离谱，这是内容行业的基本规律。这条瓜目前最大的价值不是告诉我们答案，而是展示了「不发声」会如何制造出大量互相矛盾的说法。",
  },
  {
    id: "su-tour-cancel",
    rank: 18,
    heat: 6480,
    category: "舞台争议",
    status: "已澄清",
    date: "2026-08-22",
    title: "苏晚棠巡演临时取消两站，主办方公布票务与排期冲突说明",
    summary: "取消消息来得突然，主办方第二天给了完整解释与补偿方案，情绪很快被安抚。",
    people: ["苏晚棠", "巡演主办方"],
    conflict: "场馆排期与艺人档期冲突时，观众的损失如何补偿。",
    tags: ["巡演取消", "补偿方案", "场馆排期"],
    cover: "https://readdy.ai/api/search-image?query=Empty%20concert%20venue%20rows%20of%20seats%20under%20warm%20amber%20stage%20light%2C%20cinematic%20editorial%20magazine%20aesthetic%2C%20no%20people%2C%20no%20text&width=800&height=500&seq=gw-cover-18&orientation=landscape",
    timeline: [
      { date: "8月21日", text: "两站巡演突然宣布取消，主办方仅发布简短通知。" },
      { date: "8月22日", text: "主办方补充说明场馆排期与档期冲突，并公布全额退票与交通补偿。" },
      { date: "8月22日", text: "大部分购票观众反馈可接受，话题热度回落。" },
    ],
    detail:
      "演出取消本身很难被接受，但这条瓜的结果说明：补偿方案越具体，情绪回落越快。主办方第二天给出的交通补偿细则，是这次平息争议的决定性因素。",
  },
  {
    id: "lu-endorse-rise",
    rank: 19,
    heat: 6320,
    category: "商业代言",
    status: "已落幕",
    date: "2026-08-21",
    title: "陆时安单月官宣三个新代言，商业号召力引发行业讨论",
    summary: "没有争议，纯粹的数据型话题，讨论集中在「热度如何转化成商业价值」。",
    people: ["陆时安"],
    conflict: "短期热度与长期商业价值之间是否存在错配。",
    tags: ["新代言", "商业价值", "行业讨论"],
    cover: "https://readdy.ai/api/search-image?query=Stack%20of%20elegant%20product%20boxes%20with%20warm%20amber%20studio%20lighting%2C%20cinematic%20editorial%20magazine%20aesthetic%2C%20no%20people%2C%20no%20text&width=800&height=500&seq=gw-cover-19&orientation=landscape",
    timeline: [
      { date: "8月10日", text: "第一个新品代言官宣，话题讨论度中等。" },
      { date: "8月16日", text: "第二个代言官宣，品牌方公布销售数据，讨论开始升温。" },
      { date: "8月21日", text: "第三个代言落地，行业账号开始讨论其商业模型。" },
    ],
    detail:
      "这是一条「正面数据型」话题，没有任何争议点，却依然能持续讨论近两周，原因在于它触及了行业最关心的问题：曝光和转化到底怎么对应。",
  },
  {
    id: "wen-jiang-rumor",
    rank: 20,
    heat: 6180,
    category: "恋情绯闻",
    status: "已澄清",
    date: "2026-08-20",
    title: "温亦寒与江砚辞绯闻澄清，双方均称是合作期间的正常工作往来",
    summary: "一张聚餐合照引发联想，双方在同一天先后澄清，节奏整齐到被调侃「商量好了」。",
    people: ["温亦寒", "江砚辞"],
    conflict: "「合作往来」与「私下关系」的边界如何界定。",
    tags: ["聚餐合照", "同日澄清", "工作往来"],
    cover: "https://readdy.ai/api/search-image?query=Warm%20restaurant%20table%20with%20candles%20and%20empty%20chairs%20at%20night%2C%20amber%20glow%2C%20cinematic%20editorial%20magazine%20aesthetic%2C%20no%20people%2C%20no%20text&width=800&height=500&seq=gw-cover-20&orientation=landscape",
    timeline: [
      { date: "8月19日", text: "一张多人聚餐合照被裁切成双人画面传播。" },
      { date: "8月20日", text: "双方工作室在同一小时内先后发布澄清说明。" },
      { date: "8月20日", text: "原图完整版本流出，确认现场共七人，事件收尾。" },
    ],
    detail:
      "裁剪是这类传闻最常见的操作。完整合照流出后事件立刻结束，也再次说明：当素材本身可以被还原时，澄清的成本会低很多。",
  },
  {
    id: "bai-shutdown",
    rank: 21,
    heat: 6040,
    category: "剧组风波",
    status: "持续发酵",
    date: "2026-08-19",
    title: "白鹿遥新剧被曝停工，制片方称是场景调整而非停摆",
    summary: "通告单出现连续空白，剧组强调仍在正常推进，但补拍计划始终没公布。",
    people: ["白鹿遥", "制片方"],
    conflict: "「场景调整」与「项目停摆」之间缺少可验证的中间状态。",
    tags: ["剧组停工", "通告单", "场景调整"],
    cover: "https://readdy.ai/api/search-image?query=Empty%20film%20set%20with%20lighting%20rigs%20and%20wooden%20scaffolding%20in%20warm%20amber%20dusk%20light%2C%20cinematic%20editorial%20magazine%20aesthetic%2C%20no%20people%2C%20no%20text&width=800&height=500&seq=gw-cover-21&orientation=landscape",
    timeline: [
      { date: "8月14日", text: "通告单显示连续五天无拍摄安排，引发停工猜测。" },
      { date: "8月17日", text: "制片方回应称是外景场景调整，不影响整体进度。" },
      { date: "8月19日", text: "补拍与转场计划未公布，讨论仍在继续。" },
    ],
    detail:
      "剧组的回应给出了原因，但没有给出计划，这是争议延续的核心。在影视项目里，「什么时候恢复拍摄」比「为什么暂停」更能安抚外界，而这条恰恰缺了后者。",
  },
  {
    id: "shen-education",
    rank: 22,
    heat: 5920,
    category: "形象争议",
    status: "已澄清",
    date: "2026-08-18",
    title: "沈砚清学历信息被质疑，本人晒出毕业证明回应",
    summary: "简介栏的表述被挑出问题，本人没有交给团队处理，直接发了证明材料。",
    people: ["沈砚清"],
    conflict: "公开简介的措辞准确度与公众预期之间的差。",
    tags: ["学历质疑", "毕业证明", "本人回应"],
    cover: "https://readdy.ai/api/search-image?query=Graduation%20cap%20and%20rolled%20diploma%20on%20a%20wooden%20table%20with%20warm%20amber%20light%2C%20cinematic%20editorial%20magazine%20aesthetic%2C%20no%20people%2C%20no%20text&width=800&height=500&seq=gw-cover-22&orientation=landscape",
    timeline: [
      { date: "8月17日", text: "网友指出某平台简介中的学历表述不严谨。" },
      { date: "8月18日", text: "本人发布学历证明材料，并说明简介已同步修正。" },
      { date: "8月18日", text: "相关平台修改简介，事件迅速平息。" },
    ],
    detail:
      "这类争议通常由「表述」而非「事实」引发。本人这次的处理很干脆，先给材料再改简介，两步做完，让事件在一天内自然结束。",
  },
  {
    id: "xu-variety-debut",
    rank: 23,
    heat: 5780,
    category: "综艺名场面",
    status: "已落幕",
    date: "2026-08-17",
    title: "许南枝综艺首秀表现松弛，被观众称为「最不像新人的新人」",
    summary: "一整期节目没有刻意表现，反而因为自然成为当期讨论度最高的嘉宾。",
    people: ["许南枝"],
    conflict: "「综艺感」到底是设计出来的还是自然流露的。",
    tags: ["综艺首秀", "松弛感", "讨论度"],
    cover: "https://readdy.ai/api/search-image?query=Bright%20studio%20set%20with%20warm%20amber%20spotlights%20and%20empty%20director%20chairs%2C%20cinematic%20editorial%20magazine%20aesthetic%2C%20no%20people%2C%20no%20text&width=800&height=500&seq=gw-cover-23&orientation=landscape",
    timeline: [
      { date: "8月16日", text: "节目播出，许南枝首次常驻，表现被评价为自然。" },
      { date: "8月17日", text: "多个片段被单独剪辑传播，播放数据持续走高。" },
      { date: "8月17日", text: "节目组确认其为常驻嘉宾，讨论以正面评价收尾。" },
    ],
    detail:
      "这条与「高情商救场」形成对照：前者靠一句话，后者靠整期的稳定表现。两条都说明，综艺观众对「不端着」的状态有明显偏好。",
  },
  {
    id: "tang-new-agency",
    rank: 24,
    heat: 5640,
    category: "合约解约",
    status: "已落幕",
    date: "2026-08-16",
    title: "唐以宁确认转签新公司，原公司发文祝福",
    summary: "转签过程没有任何拉扯，两家公司的公开互动成了这次事件最大的看点。",
    people: ["唐以宁"],
    conflict: "艺人流动中原公司的态度如何影响舆论走向。",
    tags: ["转签", "双方祝福", "无拉扯"],
    cover: "https://readdy.ai/api/search-image?query=Two%20signing%20pens%20resting%20on%20a%20leather%20desk%20pad%20with%20warm%20amber%20light%2C%20cinematic%20editorial%20magazine%20aesthetic%2C%20no%20people%2C%20no%20text&width=800&height=500&seq=gw-cover-24&orientation=landscape",
    timeline: [
      { date: "8月12日", text: "新公司发布签约海报，正式官宣。" },
      { date: "8月13日", text: "原公司转发并祝福，双方互动被大量讨论。" },
      { date: "8月16日", text: "新公司公布首个工作安排，事件平稳收尾。" },
    ],
    detail:
      "艺人转签通常伴随猜测，这次之所以没有争议，是因为两家公司都主动发声。原公司的转发一句，直接消灭了所有「闹翻」的想象空间。",
  },
  {
    id: "cheng-stage-accident",
    rank: 25,
    heat: 5520,
    category: "舞台争议",
    status: "已澄清",
    date: "2026-08-15",
    title: "程知遥演出中出现舞台事故，团队当晚公布现场检查结果",
    summary: "升降台异常导致演出中断几分钟，团队没有拖延，当晚就给出了说明。",
    people: ["程知遥", "演出承办方"],
    conflict: "舞台安全责任由承办方还是艺方承担。",
    tags: ["舞台事故", "升降台", "当晚说明"],
    cover: "https://readdy.ai/api/search-image?query=Stage%20truss%20and%20cables%20in%20dramatic%20warm%20amber%20backlight%20with%20haze%2C%20cinematic%20editorial%20magazine%20aesthetic%2C%20no%20people%2C%20no%20text&width=800&height=500&seq=gw-cover-25&orientation=landscape",
    timeline: [
      { date: "8月14日", text: "演出中升降台出现异常，演出中断约四分钟。" },
      { date: "8月14日", text: "艺方当晚发布说明，公布设备检查结果与后续安排。" },
      { date: "8月15日", text: "承办方补充说明并致歉，事件平稳收尾。" },
    ],
    detail:
      "安全事故最容易引发恐慌，也最考验响应速度。这次两方在 24 小时内都给出了说明，把讨论限制在技术层面，避免了情绪化扩散。",
  },
  {
    id: "ji-new-endorse",
    rank: 26,
    heat: 5360,
    category: "商业代言",
    status: "已落幕",
    date: "2026-08-14",
    title: "季言新代言官宣，物料风格变化引发审美讨论",
    summary: "一次普通的代言官宣，因为视觉风格与以往差异明显而多了一波讨论。",
    people: ["季言"],
    conflict: "艺人视觉定位调整时，粉丝预期与品牌诉求的错位。",
    tags: ["新代言", "物料风格", "审美讨论"],
    cover: "https://readdy.ai/api/search-image?query=Minimal%20product%20display%20podium%20with%20warm%20amber%20gradient%20light%20and%20soft%20shadows%2C%20cinematic%20editorial%20magazine%20aesthetic%2C%20no%20people%2C%20no%20text&width=800&height=500&seq=gw-cover-26&orientation=landscape",
    timeline: [
      { date: "8月12日", text: "品牌发布官宣物料，视觉风格与以往差异较大。" },
      { date: "8月13日", text: "粉丝就「风格是否合适」展开讨论，评价两极。" },
      { date: "8月14日", text: "品牌方公布后续投放计划，讨论逐渐转向正面。" },
    ],
    detail:
      "代言类话题通常靠数据说话，这次却靠审美。它说明艺人形象不是固定的，每次风格调整都会带来一次预期重置，而重置过程中出现讨论是正常的。",
  },
  {
    id: "ruan-age-gap",
    rank: 27,
    heat: 5240,
    category: "恋情绯闻",
    status: "待回应",
    date: "2026-08-13",
    title: "阮清和被曝姐弟恋，双方均未回应",
    summary: "同款配饰与同期行程是主要线索，但至今没有任何影像证据支撑。",
    people: ["阮清和"],
    conflict: "间接线索能否构成有效讨论依据。",
    tags: ["姐弟恋", "同款配饰", "未回应"],
    cover: "https://readdy.ai/api/search-image?query=Matching%20gold%20bracelets%20on%20dark%20velvet%20fabric%20with%20warm%20amber%20light%2C%20cinematic%20editorial%20magazine%20aesthetic%2C%20no%20people%2C%20no%20text&width=800&height=500&seq=gw-cover-27&orientation=landscape",
    timeline: [
      { date: "8月9日", text: "同款配饰被网友发现并逐步整理成对比图。" },
      { date: "8月12日", text: "行程重合的时间线被整理发布，讨论度上升。" },
      { date: "8月13日", text: "双方均未回应，事件停在待回应状态。" },
    ],
    detail:
      "这条与「订婚传闻」结构高度相似，都是靠间接线索拼接。不同之处在于本次连行程重合都难以完整核实，因此更接近讨论而非事件。",
  },
  {
    id: "huo-script",
    rank: 28,
    heat: 5120,
    category: "剧组风波",
    status: "持续发酵",
    date: "2026-08-12",
    title: "霍屿被曝与编剧就角色走向产生分歧，剧组称沟通顺畅",
    summary: "剧本讨论被传成创作冲突，剧组的口径与爆料方向完全相反。",
    people: ["霍屿", "编剧团队"],
    conflict: "演员对角色提出的意见算不算干预创作。",
    tags: ["角色走向", "剧本分歧", "沟通顺畅"],
    cover: "https://readdy.ai/api/search-image?query=Open%20notebook%20with%20pen%20on%20a%20writing%20desk%20under%20warm%20amber%20lamp%20light%2C%20cinematic%20editorial%20magazine%20aesthetic%2C%20no%20people%2C%20no%20text&width=800&height=500&seq=gw-cover-28&orientation=landscape",
    timeline: [
      { date: "8月8日", text: "爆料称某演员对角色结局提出修改意见，未点名。" },
      { date: "8月10日", text: "多方账号指向霍屿，讨论扩散。" },
      { date: "8月12日", text: "剧组回应称创作沟通一直顺畅，不存在冲突。" },
    ],
    detail:
      "演员参与剧本讨论本来是正常工作流程，被传播后才变成「冲突」。这条瓜的关键在于区分「讨论」和「干预」，而目前公开信息只支持前者。",
  },
  {
    id: "xie-privacy",
    rank: 29,
    heat: 4980,
    category: "形象争议",
    status: "待回应",
    date: "2026-08-11",
    title: "谢云深个人隐私信息被传播，团队表示已启动法律程序",
    summary: "讨论焦点从八卦转向平台责任，这次几乎没有出现二次传播的狂欢。",
    people: ["谢云深"],
    conflict: "公众人物的隐私边界与平台的内容治理责任。",
    tags: ["隐私外泄", "法律程序", "平台责任"],
    cover: "https://readdy.ai/api/search-image?query=Cracked%20dark%20glass%20texture%20with%20warm%20amber%20light%20filtering%20through%2C%20cinematic%20editorial%20magazine%20aesthetic%2C%20no%20people%2C%20no%20text&width=800&height=500&seq=gw-cover-29&orientation=landscape",
    timeline: [
      { date: "8月10日", text: "部分隐私信息在社群内被传播，随后扩散至公开平台。" },
      { date: "8月11日", text: "团队声明已启动法律程序，并呼吁不要二次传播。" },
      { date: "8月11日", text: "多个平台陆续清理相关内容，讨论转向平台责任。" },
    ],
    detail:
      "这是 30 条里性质最不同的一条。它提醒我们，并非所有「瓜」都值得追踪，涉及个人信息安全的内容，最合适的处理方式是不看、不传。",
  },
  {
    id: "qiao-golden-line",
    rank: 30,
    heat: 4820,
    category: "综艺名场面",
    status: "已落幕",
    date: "2026-08-10",
    title: "乔安禾贡献年度金句，一句话被做成上百个表情包",
    summary: "当期节目最后三分钟的一句玩笑，成了这个夏天流传最广的表达。",
    people: ["乔安禾"],
    conflict: "金句的传播度与其原本语境之间的距离越来越远。",
    tags: ["年度金句", "表情包", "传播度"],
    cover: "https://readdy.ai/api/search-image?query=Colorful%20neon%20sign%20glowing%20in%20a%20dark%20alley%20with%20warm%20amber%20reflections%2C%20cinematic%20editorial%20magazine%20aesthetic%2C%20no%20people%2C%20no%20text&width=800&height=500&seq=gw-cover-30&orientation=landscape",
    timeline: [
      { date: "8月9日", text: "节目播出后，末尾一句玩笑被观众截取传播。" },
      { date: "8月10日", text: "金句被制作成表情包与短视频配音，跨平台扩散。" },
      { date: "8月10日", text: "话题登上热搜尾部，成为当期节目最长尾的内容。" },
    ],
    detail:
      "作为 30 条盘点里的收尾，这条很合适：它没有争议，只有纯粹的语言快乐。但它也演示了同一个过程——一句话离开原始语境后，会变成完全独立的东西。",
  },
];

export const gossipVoices = [
  {
    name: "阿彻",
    tag: "追更党",
    text: "以前看这些事要翻五个平台，还经常看到互相矛盾的版本。现在直接看时间线，自己心里反而更有数了。",
  },
  {
    name: "栗子酱",
    tag: "只看结论",
    text: "最喜欢状态标签，已澄清的扫一眼就知道不用再追了，省下很多时间。",
  },
  {
    name: "南风过境",
    tag: "内容从业者",
    text: "「冲突点」这个字段很有用，它把每件事真正在争什么讲清楚了，比单纯罗列爆料有价值。",
  },
  {
    name: "小满",
    tag: "普通读者",
    text: "分类做得很清楚，我只关心剧组那类，点进去就是完整列表，不用在一堆热闹里找。",
  },
];